/* eslint-disable react/display-name */

import * as React from 'react'
import { style } from 'typestyle'
import { NestedCSSProperties } from 'typestyle/lib/types'

type StyleType = false | NestedCSSProperties | null | undefined

const styled = {
  a: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) => (
      <a className={className} {...props}>
        {props.children}
      </a>
    )
  },
  p: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>) => (
      <p className={className} {...props}>
        {props.children}
      </p>
    )
  },
  div: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => (
      <div className={className} {...props}>
        {props.children}
      </div>
    )
  },
  span: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>) => (
      <span className={className} {...props}>
        {props.children}
      </span>
    )
  },
  header: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) => (
      <header className={className} {...props}>
        {props.children}
      </header>
    )
  },
  h1: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) => (
      <h1 className={className} {...props}>
        {props.children}
      </h1>
    )
  },
  h3: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) => (
      <h3 className={className} {...props}>
        {props.children}
      </h3>
    )
  },
  footer: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) => (
      <footer className={className} {...props}>
        {props.children}
      </footer>
    )
  },
  time: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.TimeHTMLAttributes<HTMLElement>, HTMLElement>) => (
      <time className={className} {...props}>
        {props.children}
      </time>
    )
  },
  img: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => (
      <img className={className} {...props}>
        {props.children}
      </img>
    )
  },
  blockquote: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.BlockquoteHTMLAttributes<HTMLElement>, HTMLElement>) => (
      <blockquote className={className} {...props}>
        {props.children}
      </blockquote>
    )
  },
  form: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>) => (
      <form className={className} {...props}>
        {props.children}
      </form>
    )
  },
  input: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) => (
      <input className={className} {...props}>
        {props.children}
      </input>
    )
  },
  button: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) => (
      <button className={className} {...props}>
        {props.children}
      </button>
    )
  },
  iframe: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.IframeHTMLAttributes<HTMLIFrameElement>, HTMLIFrameElement>) => (
      <iframe className={className} {...props}>
        {props.children}
      </iframe>
    )
  },
  svg: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.SVGProps<SVGSVGElement>, SVGSVGElement>) => (
      <svg className={className} {...props}>
        {props.children}
      </svg>
    )
  },
  textarea: (...styles: StyleType[]) => {
    const className = style(...styles)
    return (props: React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>) => (
      <textarea className={className} {...props}>
        {props.children}
      </textarea>
    )
  },
  circle: (...styles: StyleType[]) => {
    const className = style(...styles)

    // Function components cannot be given refs,
    // so we need to forward the ref to the child component.
    return React.forwardRef<
      SVGCircleElement,
      React.DetailedHTMLProps<React.SVGProps<SVGCircleElement>, SVGCircleElement>
    >(
      (
        props: React.DetailedHTMLProps<React.SVGProps<SVGCircleElement>, SVGCircleElement>,
        ref: React.Ref<SVGCircleElement>
      ) => (
        <circle ref={ref} className={className} {...props}>
          {props.children}
        </circle>
      )
    )
  },
}

export default styled
